"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accreditDocEdoAccredit = accreditDocEdoAccredit;
exports.cancelAccredit = cancelAccredit;
exports.cancelDocEdoAccredit = cancelDocEdoAccredit;
exports.downLoadDangerousGoodsDeclaration = downLoadDangerousGoodsDeclaration;
exports.downloadDocEdoAccredit = downloadDocEdoAccredit;
exports.getBlNoDoType = getBlNoDoType;
exports.getCustomerEmail = getCustomerEmail;
exports.getForespeak = getForespeak;
exports.queryDocEdoAccredit = queryDocEdoAccredit;
exports.saveDocEdoAccredit = saveDocEdoAccredit;
exports.searchFreight = searchFreight;
exports.validateDocEdoAccredit = validateDocEdoAccredit;
var _request = _interopRequireDefault(require("@/utils/request"));
//换单预约（上海）查询
function queryDocEdoAccredit(listQuery, blNos) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/queryDocEdoAccredit?currentPage=" + listQuery.currentPage + "&pageSize=" + listQuery.pageSize,
    method: 'post',
    data: blNos
  });
}

//换单预约（上海）费用信息查询
function searchFreight(listQuery, blNoAndContainerNo) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/searchFreight?currentPage=" + listQuery.currentPage + "&pageSize=" + listQuery.pageSize + "&blNoAndContainerNo=" + blNoAndContainerNo,
    method: 'get'
  });
}

//换单预约（上海）预约获取
function getForespeak(edoAccreditId) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/getForespeak/".concat(edoAccreditId),
    method: 'post'
  });
}
function validateDocEdoAccredit(edoAccreditIds) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/validateDocEdoAccredit",
    method: 'post',
    data: edoAccreditIds
  });
}

//换单预约（上海）批量预约（弹框）取消
function cancelDocEdoAccredit(id) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/cancelDocEdoAccredit?id=" + id,
    method: 'get'
  });
}

//换单预约-上海(告客户书)下载
function downLoadDangerousGoodsDeclaration() {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/docEdoAccredit/downLoadDangerousGoodsDeclaration",
    method: 'get'
  });
}

//换单预约（上海）批量预约（弹框）下载委托书
function downloadDocEdoAccredit() {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/docEdoAccredit/downloadDocEdoAccredit",
    method: 'get'
  });
}

//换单预约（上海）批量预约（弹框）预约/保存 saveDocEdoAccredit
function saveDocEdoAccredit(data) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/saveDocEdoAccredit",
    method: 'post',
    data: data
  });
}

//换单预约（上海）授权（弹框）授权/保存
function accreditDocEdoAccredit(form) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/doAccredit?edoAccreditId2=" + form.edoAccreditId + "&sipgCustomer2=" + form.sipgCstCode + "&creditCode2=" + form.creditCode + "&cstName2=" + form.cstName + "&blNo=" + form.accreditBlNo,
    method: 'post'
  });
}

//换单预约（上海）授权（弹框）取消
function cancelAccredit(edoAccreditId) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/cancelAccredit?edoAccreditId=".concat(edoAccreditId),
    method: 'get'
  });
}

//换单预约（上海）获取舱单的提货单性质
function getBlNoDoType(blNo) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/getBlNoDoType/".concat(blNo),
    method: 'get'
  });
}
function getCustomerEmail(invoiceTitle) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/getCustomerEmail/".concat(invoiceTitle),
    method: 'post'
  });
}